import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import { Form, Grid, Row, Col, Avatar, RadioTileGroup } from 'rsuite';
import { SchemaModel, StringType } from 'schema-typed';
import api from '../../../services/api';
import RDrawer from '../../../components/Rsuite/Drawer';
import RNavbar from '../../../components/Rsuite/Navbar';
import { Icon } from '@rsuite/icons';
import { GiHamburger, GiSodaCan } from 'react-icons/gi';
import pizzaImg from '../../../assets/pizza.png';
import { useCustomTheme as useTheme } from '../../../hooks/useCustomTheme';
import { CustomInput as Input } from '../../../components/CustomInput';
import { CustomInputNumber as InputNumber } from '../../../components/CustomInputNumber';
import { CustomSelectPicker as SelectPicker } from '../../../components/CustomSelectPicker';
import { CustomButton as Button } from '../../../components/CustomButton';
import { CustomRadioTile as RadioTile } from '../../../components/CustomRadioTile';
import { CustomInputCurrency as InputCurrency } from '../../../components/CustomInputCurrency';
import Montagens from '../Montagens';
import './styles.css';
import { Spacer } from '../../../components/Spacer';
import { toastSuccess, toastWarning, toastError } from '../../../toasts';
import { InputDescontoPercentual } from './components/InputDescontoPercentual/InputDescontoPercentual';
import { getSizesPrices, mapSizesPrices } from './utils';
import { Additionals } from '../../../components/Additionals';
import { CustomCheckBox } from '../../../components/CustomCheckBox';
import { InfoDescription } from '../../../components/InfoDescription';
import { CustomToggle } from '../../../components/CustomToggle';
import { useCompany } from '../../../hooks/useCompany';
import { dataDays } from '../../../constants/dataDays';

const CadastrarProduto = ({
  modal,
  fecharModal,
  itemEdit,
  setItemEdit,
  configuracao,
  IdEmpresa,
  grupos,
  grupoSelecionado,
  produtos,
  setProdutos,
}) => {
  const product = itemEdit;
  const { company } = useCompany();
  const isPizzaGroup = grupoSelecionado?.IsPizza ?? false;
  const [formValue, setFormValue] = useState({
    Id: 0,
    Grupo: itemEdit?.Grupo ?? null,
    IdEmpresa: 0,
    Descricao: '',
    Unidade: 'UN',
    TipoProduto: isPizzaGroup ? 'PREPARADO' : 'INDUSTRIALIZADO',
    Composicao: '',
    PrecoVenda: 0,
    KgInicial: 0,
    Fracionado: 0,
    MontagemPrato: 0,
    Sequencia: 0,
    QtdMinima: 0,
    Disponivel: 1,
    IsPizza: false,
    DescontoPercentual: itemEdit?.DescontoPercentual ?? 0,
    UsaValorPrincipalSaboresPizza: 0,
    VisivelCardapio: 0,
    VisivelMenucheff: 1,
  });
  const [active, setActive] = useState(
    itemEdit || grupoSelecionado?.IsPizza ? 'detalhes' : 'tipo',
  );
  const [tamanhos, setTamanhos] = useState([]);
  const [precosTamanhos, setPrecosTamanhos] = useState([]);
  const [groupSizes, setGroupSizes] = useState([]);
  const [serveQuantasPessoas, setServeQuantasPessoas] = useState(
    product?.ServeQtdPessoas ?? 0,
  );
  const [diasDisponiveis, setDiasDisponiveis] = useState(() => {
    const raw = product?.DiasDisponiveis;
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  });
  const [montagensProduto, setMontagensProduto] = useState([]);
  const { theme } = useTheme();
  const { colors } = theme;
  const formRef = useRef();

  const sizesPrices = useMemo(
    () =>
      getSizesPrices(
        precosTamanhos,
        tamanhos,
        {
          Id: formValue.Id,
          IsPizza: formValue.IsPizza,
          TipoProduto: formValue.TipoProduto,
        },
        groupSizes,
      ),
    [
      precosTamanhos,
      tamanhos,
      groupSizes,
      formValue.Id,
      formValue.IsPizza,
      formValue.TipoProduto,
    ],
  );

  const showBackButton = useMemo(
    () =>
      active !== 'tipo' &&
      ((active === 'detalhes' && !itemEdit && !grupoSelecionado?.IsPizza) ||
        active !== 'detalhes'),
    [active],
  );

  const selectUnidade = [
    'CX - CAIXA',
    'PT - PACOTE',
    'KG - KILOGRAMA',
    'UN - UNIDADE',
    'BA - BANDEJA',
    'MC - MAÇO',
  ].map((item) => ({
    label: item,
    value: item?.split(' -')[0],
  }));

  const selectTipoProduto = [
    { label: 'Preparado', value: 'PREPARADO' },
    { label: 'Industrializado', value: 'INDUSTRIALIZADO' },
  ];

  const formatacaoCamposPrecos = ['PrecoVenda', 'ValorDesconto'];
  const fieldsTypeNumber = ['CodigoPDV', 'Sequencia', 'QtdMinima'];

  const estiloLabels = {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  };

  const model = SchemaModel({
    Descricao: StringType().isRequired('Descrição é obrigatória'),
    TipoProduto: StringType().isRequired('O tipo do produto é obrigatório'),
    Grupo: StringType().isRequired('O grupo é obrigatório'),
  });

  const updateTabs = useCallback(
    (item) => {
      switch (active) {
        case 'detalhes':
          setActive('precos');
          break;
        case 'precos':
          if (item.MontagemPrato) {
            setActive('montagemPrato');
          } else {
            fecharModal();
          }
          break;
        default:
          fecharModal();
      }
    },
    [active, fecharModal],
  );

  const handleSubmit = async () => {
    if (!formRef.current.check()) {
      return;
    }

    let objetoSubmit = {
      ...formValue,
      ServeQtdPessoas: serveQuantasPessoas,
      DiasDisponiveis: diasDisponiveis.length > 0 ? diasDisponiveis : null,
    };

    formatacaoCamposPrecos.forEach((item) => {
      const value =
        typeof objetoSubmit[item] === 'string'
          ? objetoSubmit[item]?.replace(',', '.')
          : +objetoSubmit[item];
      objetoSubmit[item] = isNaN(value) ? 0 : +value;
    });

    fieldsTypeNumber.forEach((field) => {
      const value = Number(objetoSubmit[field]);
      objetoSubmit[field] = Number.isNaN(value) ? 0 : value;
    });

    if (!itemEdit) {
      if (!configuracao.IntegracaoUnicheff) {
        objetoSubmit.IdEmpresa = IdEmpresa;
        delete objetoSubmit.Id;

        createProduct(objetoSubmit);
      } else {
        toastWarning('Sistema integrado com o Unicheff!');
      }
    } else {
      delete objetoSubmit.IdEmpresa;
      delete objetoSubmit.DataCadastro;
      updateProduct(objetoSubmit);
    }
  };

  const removeUnusedKeys = (object_to_parse) => {
    const sizeKeys = Object.keys(object_to_parse).filter((key) =>
      key.includes('size'),
    );

    const objectData = {
      ...object_to_parse,
    };

    sizeKeys.forEach((key) => {
      delete objectData[key];
    });

    return objectData;
  };

  const updateProduct = async (objetoSubmit) => {
    const objectData = removeUnusedKeys(objetoSubmit);
    await api
      .patch(`produto/alterar/${objetoSubmit.Id}`, objectData)
      .then((res) => {
        objetoSubmit.Id = res.data.Id;
        listPricesSize(res.data, objetoSubmit);
        toastSuccess('Registro alterado com sucesso!');

        updateTabs(res.data);
        setItemEdit(res.data);
        const novaLista = produtos.map((item) => {
          return item.Id === objetoSubmit.Id
            ? { ...item, ...objetoSubmit, ...res.data }
            : item;
        });
        setProdutos(novaLista);
      })
      .catch((error) => {
        toastError('Erro ao editar');
        console.log(error);
      });
  };

  const createProduct = async (objetoSubmit) => {
    await api
      .post('produto/criar', objetoSubmit)
      .then((res) => {
        objetoSubmit.Id = res.data.Id;
        updateTabs(res.data);
        setItemEdit(res.data);
        setFormValue(res.data);
        listPricesSize(res.data, objetoSubmit);
        toastSuccess('Registro salvo com sucesso!');
        setProdutos([...produtos, { ...res.data }]);
      })
      .catch((error) => {
        toastError('Erro ao cadastrar o produto');
        console.log(error);
      });
  };

  const listSizes = (grupoOverride) => {
    const grupoAtual = grupoOverride ?? formValue.Grupo ?? product?.Grupo;
    const novoGrupo = grupos?.find((g) => g.Id === grupoAtual);
    const isPizza =
      novoGrupo?.IsPizza ||
      product?.IsPizza ||
      formValue?.IsPizza ||
      product?.TipoProduto === 'PIZZA';

    (async () => {
      try {
        const sizeEndpoint = isPizza
          ? `tamanho/listar_pizzas/${IdEmpresa}`
          : `tamanho/listar/${grupoAtual}`;

        const { data } = await api.get(sizeEndpoint);
        setTamanhos(data);
      } catch (error) {
        console.log(error);
      }
    })();

    (async () => {
      try {
        const { data } = await api.get(
          `grupo-tamanhos/listar_company/${IdEmpresa}`,
        );
        if (Array.isArray(data)) {
          const filterd = data.filter((item) => item.IdGrupo === grupoAtual);
          setGroupSizes(filterd);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  };

  const listPricesSize = useCallback(async (itemEdit) => {
    await api
      .get(`produto-tamanho/listarPorProduto/${itemEdit.Id}`)
      .then((response) => {
        setPrecosTamanhos(response.data);
      });
  }, []);

  const updateData = useCallback(async () => {
    let objMontado = { ...itemEdit };
    formatacaoCamposPrecos.forEach((item) => {
      objMontado[item] = +objMontado[item];
    });
    listPricesSize(itemEdit);
    setFormValue(objMontado);
    const raw = itemEdit?.DiasDisponiveis;
    if (!raw) {
      setDiasDisponiveis([]);
    } else if (Array.isArray(raw)) {
      setDiasDisponiveis(raw);
    } else {
      try {
        setDiasDisponiveis(JSON.parse(raw));
      } catch {
        setDiasDisponiveis([]);
      }
    }
  }, []);

  function handleChangeTipo(value) {
    setFormValue((prev) => ({
      ...prev,
      TipoProduto: value,
    }));
    setActive('detalhes');
  }

  const handlePriceChange = useCallback((tamanho, field, value) => {
    setPrecosTamanhos((prev) => {
      const index = prev.findIndex(
        (item) => item.IdTamanho === tamanho.IdTamanho,
      );
      if (index !== -1) {
        return prev.map((item, idx) =>
          idx === index ? { ...item, [field]: value } : item,
        );
      } else {
        const newItem = {
          ...tamanho,
          [field]: value,
        };
        return [...prev, newItem];
      }
    });
  }, []);

  async function savePrices() {
    if (precosTamanhos?.length === 0) {
      return handleSubmit();
    }

    try {
      const pricesPromise = precosTamanhos.map(mapSizesPrices);

      const result = await Promise.allSettled(pricesPromise);

      const error = result.find((res) => res.status === 'rejected');

      if (error) {
        return toastError('Erro ao cadastrar o preços');
      }

      toastSuccess('Preços salvos com sucesso');
    } catch (err) {
      toastError('Erro ao cadastrar o preços');
      console.log(err);
    }
  }

  function handleHasDesconto() {
    setFormValue(({ HasDesconto, HasDescontoPercentual, ...prev }) => ({
      ...prev,
      HasDesconto: !HasDesconto,
      HasDescontoPercentual: HasDesconto ? HasDescontoPercentual : false,
    }));
  }

  function handleHasDescontoPercentual() {
    setFormValue((prev) => ({
      ...prev,
      HasDescontoPercentual: prev?.HasDescontoPercentual ? 0 : 1,
      HasDesconto: prev.HasDescontoPercentual ? prev.HasDesconto : false,
    }));
  }

  const handleUsarValorPrincipalSabores = useCallback(() => {
    setFormValue((prev) => ({
      ...prev,
      UsaValorPrincipalSaboresPizza: prev.UsaValorPrincipalSaboresPizza ? 0 : 1,
    }));
  }, []);

  const handleIsPizza = useCallback(() => {
    setFormValue((prev) => ({
      ...prev,
      IsPizza: prev.IsPizza ? false : true,
    }));
  }, []);

  const handleUpdateProductMounting = async (isClose) => {
    if (
      !itemEdit?.MontagemPrato &&
      (!montagensProduto || montagensProduto.length === 0)
    ) {
      return;
    }

    if (itemEdit?.MontagemPrato && montagensProduto.length === 0) {
      itemEdit.MontagemPrato = 0;
    }

    try {
      const { Id, ...updatedData } = itemEdit;

      const { data } = await api.patch(`produto/alterar/${itemEdit.Id}`, {
        ...updatedData,
      });

      setItemEdit(data);
      setProdutos((prev) =>
        prev.map((prev_prod) => (prev_prod.Id !== data.Id ? prev_prod : data)),
      );

      if (isClose) {
        return;
      }

      toastSuccess('Produto salvo com sucesso!');
    } catch (err) {
      console.log(err);
      toastError('Erro ao atualizar o produto!');
    }
  };

  function handleConfirm() {
    if (active === 'tipo' && !!formValue.TipoProduto) {
      setActive('detalhes');
    }

    if (active === 'detalhes') {
      handleSubmit();
    }

    if (active === 'precos') {
      handleSubmit();
      savePrices();
      if (formValue?.MontagemPrato) {
        setActive('montagemPrato');
        return;
      }

      setActive('adicionais');
    }

    if (active === 'montagemPrato') {
      handleUpdateProductMounting();
    }
  }

  const handleClose = () => {
    handleUpdateProductMounting(true);
    fecharModal();
  };

  const parseToSelectOptions = (list, label, value) => {
    return list.map((curr) => ({
      label: curr[label],
      value: curr[value],
    }));
  };

  const handleDeleteProduct = async () => {
    try {
      const id = itemEdit?.Id;
      if (!id) {
        toastError('Não foi possivel apagar produto.');
        return console.log('must have a product');
      }

      await api.delete(`/produto/excluir/${id}`);

      fecharModal();
      setItemEdit(null);
      setProdutos((prev) => prev.filter((product) => product.Id !== id));
      toastSuccess('Produto apagado com sucesso.');
    } catch (error) {
      const errorMessage = error?.response?.data?.message || '';
      console.log({ error });
      toastError(errorMessage);
    }
  };

  useEffect(() => {
    if (itemEdit !== null) {
      updateData();
    } else {
      setFormValue({ ...formValue, Grupo: grupoSelecionado.Id });
    }
  }, []);

  useEffect(() => {
    listSizes();
  }, [formValue.TipoProduto]);

  const prevGrupo = useRef(itemEdit?.Grupo ?? null);
  useEffect(() => {
    if (prevGrupo.current === undefined) {
      prevGrupo.current = formValue.Grupo;
      return;
    }
    if (prevGrupo.current === formValue.Grupo) return;
    prevGrupo.current = formValue.Grupo;

    const novoGrupo = grupos?.find((g) => g.Id === formValue.Grupo);
    if (novoGrupo?.IsPizza) {
      setFormValue((prev) => ({
        ...prev,
        IsPizza: 1,
        TipoProduto: 'PREPARADO',
      }));
    }
    listSizes(formValue.Grupo);
  }, [formValue.Grupo]);

  return (
    <RDrawer
      backdrop={'static'}
      open={modal}
      onClose={handleClose}
      // title="Cadastro de Produto"
      style={{ width: 850, maxWidth: window.innerWidth }}
      actions={<></>}
    >
      <RNavbar
        active={active}
        setActive={setActive}
        navItens={[
          !itemEdit &&
            !grupoSelecionado?.IsPizza && {
              key: 'tipo',
              name: 'Tipo',
              disabled: true,
              hidden: true,
            },
          {
            key: 'detalhes',
            name: 'Detalhes',
            disabled: !itemEdit,
            hidden: false,
          },
          {
            key: 'precos',
            name: 'Preços',
            disabled: !itemEdit,
          },
          {
            key: 'montagemPrato',
            name: 'Montagem de Pratos',
            disabled: !itemEdit,
          },
          {
            key: 'adicionais',
            name: 'Adicionais',
            disabled: !itemEdit,
          },
        ]}
      />
      <Form
        ref={formRef}
        model={model}
        onChange={setFormValue}
        onSubmit={handleSubmit}
        formValue={formValue}
        fluid
      >
        <Grid
          fluid
          style={{ height: 'calc(100vh - 190px)', overflowY: 'scroll' }}
        >
          {active === 'tipo' && (
            <Row>
              <Col xs={24} sm={24} md={24}>
                <RadioTileGroup
                  onChange={handleChangeTipo}
                  value={formValue.TipoProduto}
                >
                  <RadioTile
                    label="Preparado"
                    value="PREPARADO"
                    icon={
                      <Icon as={GiHamburger} color={colors.textSecondary} />
                    }
                  >
                    Produtos preparados no estabelecimento ex: pizza,
                    hamburguer, sucos naturais.
                  </RadioTile>
                  <RadioTile
                    label="Industrializado"
                    value="INDUSTRIALIZADO"
                    icon={<Icon as={GiSodaCan} color={colors.textSecondary} />}
                  >
                    Produtos pronto para o consumo ex: refrigerante.
                  </RadioTile>
                </RadioTileGroup>
              </Col>
            </Row>
          )}
          {active === 'detalhes' && (
            <>
              <Row style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Group controlId="Descricao">
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Descrição
                    </Form.ControlLabel>
                    <Form.Control
                      placeholder="Digite a descrição"
                      name="Descricao"
                      accepter={Input}
                      autoComplete="off"
                      autoFocus={true}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xs={24} sm={24} md={5}>
                  <Form.Group controlId="TipoProduto">
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Tipo de Produto
                    </Form.ControlLabel>
                    <Form.Control
                      name="TipoProduto"
                      data={selectTipoProduto}
                      accepter={({ ...rest }) => (
                        <SelectPicker
                          {...rest}
                          searchable={false}
                          cleanable={false}
                        />
                      )}
                      style={{ width: '100%' }}
                      disabled={
                        !!(
                          isPizzaGroup ||
                          grupos?.find((g) => g.Id === formValue.Grupo)
                            ?.IsPizza ||
                          formValue.IsPizza
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col xs={24} sm={24} md={5}>
                  <Form.Group controlId="Unidade">
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Unidade
                    </Form.ControlLabel>
                    <Form.Control
                      name="Unidade"
                      data={selectUnidade}
                      accepter={({ ...rest }) => (
                        <SelectPicker {...rest} searchable={false} />
                      )}
                      style={{ width: '100%' }}
                    />
                  </Form.Group>
                </Col>
                <Col xs={24} sm={24} md={6}>
                  <Form.Group controlId="Grupo">
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Grupo
                    </Form.ControlLabel>
                    <Form.Control
                      name="Grupo"
                      data={parseToSelectOptions(grupos, 'Descricao', 'Id')}
                      accepter={({ ...rest }) => (
                        <SelectPicker {...rest} searchable={false} />
                      )}
                      style={{ width: '100%' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={24} md={24}>
                  <Form.Group controlId="Composicao">
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Composição
                    </Form.ControlLabel>
                    <Form.Control
                      placeholder="Descreva de que o produto é composto"
                      name="Composicao"
                      accepter={Input}
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Group controlId="CodigoPDV">
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Codigo PDV
                    </Form.ControlLabel>
                    <Form.Control
                      name="CodigoPDV"
                      accepter={InputNumber}
                      style={{ width: '100%' }}
                    />
                  </Form.Group>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Group controlId="Sequencia">
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Sequência no Cardapio
                    </Form.ControlLabel>
                    <Form.Control
                      name="Sequencia"
                      accepter={InputNumber}
                      min={0}
                      style={{ width: '100%' }}
                    />
                  </Form.Group>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Group controlId="QtdMinima">
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Quantidade minima de venda
                    </Form.ControlLabel>
                    <Form.Control
                      name="QtdMinima"
                      accepter={InputNumber}
                      min={0}
                      max={10}
                      style={{ width: '100%' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ paddingTop: '20px' }}>
                <Col sx={16}>
                  <Form.Group>
                    <Form.ControlLabel
                      style={{
                        ...estiloLabels,
                        color: colors.textSecondary,
                      }}
                    >
                      Serve quantas pessoas
                    </Form.ControlLabel>
                    <RadioTileGroup
                      inline
                      value={+serveQuantasPessoas}
                      onChange={setServeQuantasPessoas}
                    >
                      <RadioTile label="1 Pessoa" value={1} />
                      <RadioTile label="2 Pessoas" value={2} />
                      <RadioTile label="3 Pessoas" value={3} />
                      <RadioTile label="4 Pessoas" value={4} />
                    </RadioTileGroup>
                  </Form.Group>
                </Col>
                <Col sx={8} style={{ paddingTop: '25px' }}>
                  <InputNumber
                    style={{
                      maxWidth: 80,
                      border: `2px solid ${
                        serveQuantasPessoas > 4 ? colors.primary : 'transparent'
                      }`,
                    }}
                    id="numero-pessoas-input"
                    placeholder="ex: 7"
                    onChange={(num) => {
                      const numero = Number(num);
                      const numeroPessoas = numero < 1 ? 1 : numero;
                      setServeQuantasPessoas(numeroPessoas);
                    }}
                    value={+serveQuantasPessoas}
                  />
                </Col>
              </Row>
              <Row style={{ margin: '20px 0px' }}>
                <Col>
                  <Form.ControlLabel
                    style={{
                      ...estiloLabels,
                      color: colors.textSecondary,
                      marginBottom: 8,
                    }}
                  >
                    Dias disponíveis
                  </Form.ControlLabel>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {dataDays.map((day) => {
                      const active = diasDisponiveis.includes(day.value);
                      return (
                        <button
                          key={day.value}
                          type="button"
                          onClick={() =>
                            setDiasDisponiveis((prev) =>
                              active
                                ? prev.filter((d) => d !== day.value)
                                : [...prev, day.value],
                            )
                          }
                          style={{
                            padding: '5px 12px',
                            borderRadius: 6,
                            border: `2px solid ${active ? colors.primary : colors.lightGray}`,
                            background: active ? colors.primary : 'transparent',
                            color: active ? '#fff' : colors.textSecondary,
                            fontSize: 12,
                            fontWeight: active ? 700 : 500,
                            cursor: 'pointer',
                            transition: 'all 0.15s',
                          }}
                        >
                          {day.label.substring(0, 3)}
                        </button>
                      );
                    })}
                  </div>
                  <p
                    style={{
                      fontSize: 11,
                      color: colors.textSecondary,
                      marginTop: 6,
                      opacity: 0.7,
                    }}
                  >
                    {diasDisponiveis.length === 0
                      ? 'Nenhum dia selecionado — disponível todos os dias'
                      : `Disponível: ${dataDays
                          .filter((d) => diasDisponiveis.includes(d.value))
                          .map((d) => d.label)
                          .join(', ')}`}
                  </p>
                </Col>
              </Row>
              <Row style={{ marginBottom: '20px' }}>
                <Col
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#fff',
                    borderRadius: 10,
                    padding: 10,
                    margin: '0px 5px',
                  }}
                >
                  <InfoDescription
                    label="Disponível no menucheff delivery"
                    description="Habilite para que o produto apareça no menucheff delivery do cliente.
                      Desabilite para ocultar o produto do delivery, mas mantendo os itens ativos para venda no menucheff."
                  />
                  <CustomToggle
                    id="cobrarMaior"
                    checked={formValue.VisivelMenucheff}
                    onChange={() =>
                      setFormValue((prev) => ({
                        ...prev,
                        VisivelMenucheff: !prev.VisivelMenucheff,
                      }))
                    }
                  />
                </Col>
              </Row>
              {!!company.CardapioAtivo && (
                <Row style={{ marginBottom: '20px' }}>
                  <Col
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      backgroundColor: '#fff',
                      borderRadius: 10,
                      padding: 10,
                      margin: '0px 5px',
                    }}
                  >
                    <InfoDescription
                      label="Disponível no cardápio digital"
                      description="Habilite para que o produto apareça no cardápio digital do cliente.
                      Desabilite para ocultar o produto do cardápio, mas mantendo os itens ativos para venda no menucheff."
                    />
                    <CustomToggle
                      id="cobrarMaior"
                      checked={formValue.VisivelCardapio}
                      onChange={() =>
                        setFormValue((prev) => ({
                          ...prev,
                          VisivelCardapio: !prev.VisivelCardapio,
                        }))
                      }
                    />
                  </Col>
                </Row>
              )}
            </>
          )}

          {active === 'precos' && (
            <Row style={{ margin: '10px' }}>
              <Row style={{ marginLeft: '10px' }}>
                <Col>
                  <Form.ControlLabel
                    style={{
                      ...estiloLabels,
                      color: 'transparent',
                    }}
                  >
                    _
                  </Form.ControlLabel>
                  <Button onClick={handleHasDesconto}>
                    {!!formValue?.HasDesconto
                      ? 'Desativar Desconto (Valor)'
                      : 'Ativar Desconto (Valor)'}
                  </Button>
                </Col>
                <Col>
                  <Form.ControlLabel
                    style={{
                      ...estiloLabels,
                      color: 'transparent',
                    }}
                  >
                    _
                  </Form.ControlLabel>
                  <Button onClick={handleHasDescontoPercentual}>
                    {!!formValue?.HasDescontoPercentual
                      ? 'Desativar Desconto Percentual'
                      : 'Ativar Desconto Percentual'}
                  </Button>
                </Col>
              </Row>
              <Spacer y={20} />
              <Row
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  marginLeft: '10px',
                }}
              >
                {(formValue.TipoProduto === 'INDUSTRIALIZADO' ||
                  (formValue.TipoProduto === 'PREPARADO' &&
                    sizesPrices.length === 0)) && (
                  <Col xs={24} sm={12} md={6}>
                    <Form.Group controlId="Sequencia" style={{ minWidth: 100 }}>
                      <Form.ControlLabel
                        style={{
                          ...estiloLabels,
                          color: colors.textSecondary,
                        }}
                      >
                        Preço de Venda
                      </Form.ControlLabel>
                      <Form.Control
                        name="PrecoVenda"
                        min={0}
                        style={{ width: '100%' }}
                      />
                    </Form.Group>
                  </Col>
                )}
                {!!formValue.HasDescontoPercentual && (
                  <Col>
                    <Form.Group
                      controlId="DescontoPercentual"
                      style={{ minWidth: 100, maxWidth: 150 }}
                    >
                      <Form.ControlLabel
                        style={{
                          ...estiloLabels,
                          color: colors.textSecondary,
                        }}
                      >
                        Percentual Desconto
                      </Form.ControlLabel>
                      <Form.Control
                        name="DescontoPercentual"
                        accepter={InputDescontoPercentual}
                        min={0}
                        max={100}
                        style={{ width: '100%' }}
                      />
                    </Form.Group>
                  </Col>
                )}
                {(formValue.TipoProduto === 'INDUSTRIALIZADO' ||
                  (formValue.TipoProduto === 'PREPARADO' &&
                    sizesPrices.length === 0)) &&
                  !!formValue?.HasDesconto && (
                    <Col xs={24} sm={12} md={6}>
                      <Spacer x={20} />
                      <Form.Group
                        controlId="Sequencia"
                        style={{ minWidth: 100 }}
                      >
                        <Form.ControlLabel
                          style={{
                            ...estiloLabels,
                            color: colors.textSecondary,
                          }}
                        >
                          Preço com desconto
                        </Form.ControlLabel>
                        <Form.Control
                          name="ValorDesconto"
                          accepter={InputCurrency}
                          min={0}
                          style={{ width: '100%' }}
                        />
                      </Form.Group>
                    </Col>
                  )}
                {(formValue.TipoProduto === 'INDUSTRIALIZADO' ||
                  (formValue.TipoProduto === 'PREPARADO' &&
                    sizesPrices.length === 0)) &&
                  !!formValue?.HasDescontoPercentual && (
                    <Col xs={24} sm={12} md={6}>
                      <Spacer x={20} />
                      <Form.Group
                        controlId="Sequencia"
                        style={{ minWidth: 100 }}
                      >
                        <Form.ControlLabel
                          style={{
                            ...estiloLabels,
                            color: colors.textSecondary,
                          }}
                        >
                          Preço com desconto
                        </Form.ControlLabel>
                        <Form.Control
                          accepter={InputCurrency}
                          min={0}
                          style={{ width: '100%' }}
                          value={(
                            formValue.PrecoVenda *
                            (1 - formValue?.DescontoPercentual / 100)
                          ).toFixed(2)}
                          disabled
                        />
                      </Form.Group>
                    </Col>
                  )}
              </Row>

              {isPizzaGroup && (
                <Row style={{ margin: '10px 0px' }}>
                  <CustomCheckBox
                    onClick={handleIsPizza}
                    checked={!!formValue.IsPizza}
                  >
                    Tipo pizza?
                  </CustomCheckBox>
                </Row>
              )}

              {formValue.TipoProduto === 'PREPARADO' &&
                sizesPrices.length > 0 && (
                  <>
                    {!!formValue.IsPizza && (
                      <Row style={{ margin: '10px 0px' }}>
                        <CustomCheckBox
                          onClick={handleUsarValorPrincipalSabores}
                          checked={!!formValue.UsaValorPrincipalSaboresPizza}
                        >
                          <div>Usar preço principal nos sabores</div>
                        </CustomCheckBox>
                      </Row>
                    )}
                    {sizesPrices.map((tamanho) => (
                      <Col
                        xs={24}
                        sm={12}
                        md={6}
                        key={tamanho.Id}
                        style={{
                          padding: '10px',
                        }}
                      >
                        <div
                          style={{
                            border: `1px solid ${colors.backgroundSecondary}`,
                            padding: '10px',
                            borderRadius: '12px',
                            textAlign: 'center',
                          }}
                        >
                          {!!formValue.IsPizza && (
                            <Avatar
                              size="lg"
                              circle
                              src={pizzaImg}
                              alt="pizza"
                              style={{ opacity: 0.8 }}
                            />
                          )}
                          <Form.Group controlId="Sequencia">
                            <Form.ControlLabel
                              style={{
                                ...estiloLabels,
                                color: colors.textSecondary,
                              }}
                            >
                              {tamanho.Descricao}
                            </Form.ControlLabel>
                            <Form.Control
                              name={'size-prices'}
                              accepter={InputCurrency}
                              value={tamanho?.Preco || ''}
                              onChange={(text) =>
                                handlePriceChange(tamanho, 'Preco', text)
                              }
                              min={0}
                              style={{ width: '100%' }}
                            />
                            {!!formValue?.HasDesconto && (
                              <>
                                <Spacer y={10} />
                                <Form.ControlLabel
                                  style={{
                                    ...estiloLabels,
                                    color: colors.textSecondary,
                                  }}
                                >
                                  Com desconto
                                </Form.ControlLabel>
                                <Form.Control
                                  name={'size-discout-prices'}
                                  accepter={InputCurrency}
                                  value={tamanho?.PrecoDesconto || ''}
                                  onChange={(text) =>
                                    handlePriceChange(
                                      tamanho,
                                      'PrecoDesconto',
                                      text,
                                    )
                                  }
                                  min={0}
                                  style={{ width: '100%' }}
                                />
                              </>
                            )}
                            {!!formValue?.HasDescontoPercentual && (
                              <>
                                <Spacer y={10} />
                                <Form.ControlLabel
                                  style={{
                                    ...estiloLabels,
                                    color: colors.textSecondary,
                                  }}
                                >
                                  Com desconto
                                </Form.ControlLabel>
                                <Form.Control
                                  accepter={InputCurrency}
                                  name={'size-discout-prices'}
                                  value={(
                                    tamanho?.Preco *
                                    (1 - formValue?.DescontoPercentual / 100)
                                  ).toFixed(2)}
                                  style={{ width: '100%' }}
                                  disabled
                                />
                              </>
                            )}
                            <Spacer y={10} />
                            <Form.ControlLabel
                              style={{
                                ...estiloLabels,
                                color: colors.textSecondary,
                              }}
                            >
                              Codigo PDV
                            </Form.ControlLabel>
                            <Form.Control
                              accepter={Input}
                              value={tamanho?.CodigoPDV || ''}
                              name="size-pdv-code"
                              onChange={(text) =>
                                handlePriceChange(tamanho, 'CodigoPDV', text)
                              }
                              style={{ width: '100%' }}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                    ))}
                  </>
                )}
            </Row>
          )}
          {active === 'montagemPrato' && (
            <Montagens
              product={itemEdit}
              setProduct={setItemEdit}
              montagensProduto={montagensProduto}
              setMontagensProduto={setMontagensProduto}
            />
          )}
          {active === 'adicionais' && itemEdit && (
            <Additionals product={itemEdit} />
          )}
        </Grid>
        <Row
          style={{
            position: 'fixed',
            bottom: 15,
            right: 25,
            left: 25,
            display: 'flex',
            justifyContent: 'end',
            gap: 10,
          }}
        >
          <Button
            size="lg"
            appearance="subtle"
            title="Apagar Produto caso não tenha vendas registradas"
            onClick={handleDeleteProduct}
          >
            Apagar Produto
          </Button>

          <Spacer flex={1} />

          <Button onClick={handleClose} appearance="subtle" size="lg">
            Fechar
          </Button>
          {showBackButton && (
            <Button
              onClick={() =>
                setActive((prev) =>
                  prev === 'detalhes'
                    ? 'tipo'
                    : prev === 'precos'
                      ? 'detalhes'
                      : 'precos',
                )
              }
              appearance="default"
              size="lg"
            >
              Voltar
            </Button>
          )}
          <Button
            onClick={handleConfirm}
            appearance="primary"
            size="lg"
            style={{ marginLeft: 5 }}
          >
            {(active !== 'detalhes' && active !== 'tipo') || itemEdit
              ? 'Salvar'
              : 'Continuar'}
          </Button>
        </Row>
      </Form>
    </RDrawer>
  );
};

export default CadastrarProduto;
